export default {
  SET_NAVBAR_VISIBILITY(state, visibilty) {
    state.resp_nav_visivible = visibilty;
  },
};
